import { useMutation, useQueryClient } from "@tanstack/react-query";

import { CreateUserPersonalTokenRequestClientModel } from "../../api/v1";

import useAccountsApi from "./use-accounts-api";
import { CLIENT_LIST_USER_TOKENS } from "./query-keys";

export default function useClientCreateUserToken() {
  const queryClient = useQueryClient();
  const api = useAccountsApi();

  const {
    mutate: createUserToken,
    mutateAsync: createUserTokenAsync,
    ...rest
  } = useMutation(
    async (payload: CreateUserPersonalTokenRequestClientModel) => {
      const res = await api.clientCreateUserToken({
        createUserPersonalTokenRequestClientModel: payload,
      });
      return res;
    },
    {
      onSuccess: () =>
        queryClient.invalidateQueries({
          queryKey: [CLIENT_LIST_USER_TOKENS],
        }),
    },
  );

  return {
    createUserToken,
    createUserTokenAsync,
    ...rest,
  };
}
